const mutations = {
    toggleLoading(state) {
        state.loading = !state.loading;
    },
    toggleBusinessUnitPanel(state) {
        state.isBusinessUnitPanelVisible = !state.isBusinessUnitPanelVisible
    },
    toggleDateTimePanel(state) {
        state.isDateTimePanelVisible = !state.isDateTimePanelVisible
    },
    updateDateTabItem(state, tabIndex) {
        state.dateTabItem = tabIndex;
    },
    toggleFiltersPanel(state) {
        state.isFiltersPanelVisible = !state.isFiltersPanelVisible
    },
    updateAlias(state, aliasList) {
        state.alias = aliasList;
    },

    updateIsDirtySearch(state, value) {
        state.isDirtySearch = value;
    },

    // Filters
    updateFilters(state, filters) {
        state.filters = filters;
        state.isDirtySearch = true;
    },
    updateFilter(state, payload) {
        Object.assign(payload.src, payload.filter);
        state.isDirtySearch = true;
    },
    addFilter(state, filter) {
        state.filters.push(filter);
        state.isDirtySearch = true;
    },
    removeFilter(state, filter) {
        state.filters = state.filters.filter(value => value != filter);
        state.isDirtySearch = true;
    },

    // Search Query
    updateSearchQueryStr(state, payload) {
        state.searchQueryStr = payload.trim();
        state.isDirtySearch = true;
    },

    // Date
    updateBeginDate(state, date) {
        state.beginDate = date;
        state.isDirtySearch = true;
    },
    updateEndDate(state, date) {
        state.endDate = date;
        state.isDirtySearch = true;
    },

    // Poslog
    updatePoslogsList(state, newPoslogsList) {
        state.poslogs = newPoslogsList;
    },
    updateNbMaxPoslogs(state, nbMaxPoslogs) {
        state.nbMaxPoslogs = nbMaxPoslogs;
    },
    updatePoslogsTableOptions(state, poslogsTableOptions) {
        state.poslogsTableOptions = poslogsTableOptions;
    }
};

export default mutations;
